import React from 'react';

// Clean minimal airplane icon - airport signage style
const AirplaneIcon = ({ color = '#0066FF', size = 28 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill={color}
    style={{ 
      filter: `drop-shadow(0 0 6px ${color}66)`,
    }}
  >
    <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
  </svg>
);

// SVG flight path visualization - always centered with clean airplane icon
const FlightPath = ({ accentColor = '#0066FF' }) => {
  // Fixed positions for a centered, symmetric arc
  const x1 = 40;  // Left departure point
  const x2 = 360; // Right arrival point
  const y1 = 140; // Vertical position for endpoints
  const y2 = 140;
  const midX = 200; // Center
  const controlY = 40; // Arc peak height

  const path = `M ${x1} ${y1} Q ${midX} ${controlY} ${x2} ${y2}`;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <svg 
        viewBox="0 0 400 200" 
        style={{ 
          width: '100%', 
          height: '100%',
          opacity: 0.6,
        }}
      >
        {/* Grid lines for tech effect */}
        <defs>
          <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path 
              d="M 20 0 L 0 0 0 20" 
              fill="none" 
              stroke={accentColor} 
              strokeWidth="0.3" 
              opacity="0.2"
            />
          </pattern>
          <linearGradient id="pathGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={accentColor} stopOpacity="0.3" />
            <stop offset="50%" stopColor={accentColor} stopOpacity="1" />
            <stop offset="100%" stopColor={accentColor} stopOpacity="0.3" />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* Background grid */}
        <rect width="400" height="200" fill="url(#grid)" />

        {/* Flight path arc */}
        <path
          d={path}
          fill="none"
          stroke="url(#pathGradient)"
          strokeWidth="2"
          strokeLinecap="round"
          filter="url(#glow)"
        />

        {/* Departure point */}
        <circle cx={x1} cy={y1} r="6" fill="#0a0a0a" stroke={accentColor} strokeWidth="2" />
        <circle cx={x1} cy={y1} r="3" fill={accentColor} />

        {/* Arrival point */}
        <circle cx={x2} cy={y2} r="6" fill="#0a0a0a" stroke={accentColor} strokeWidth="2" />
        <circle cx={x2} cy={y2} r="3" fill={accentColor} />
      </svg>

      {/* Clean airplane icon at arc peak */}
      <div style={{
        position: 'absolute',
        top: '12%',
        left: '50%',
        transform: 'translateX(-50%) rotate(90deg)',
        opacity: 0.95,
      }}>
        <AirplaneIcon color={accentColor} size={28} />
      </div>
    </div>
  );
};

export default FlightPath;
